import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
  MsalBroadcastService,
  MsalGuard,
  MsalGuardConfiguration,
  MsalInterceptor,
  MsalInterceptorConfiguration,
  MsalModule,
  MsalRedirectComponent,
  MsalService,
} from '@azure/msal-angular';
import { BrowserCacheLocation, InteractionType, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { environment } from '../../../../apps/admin-panel/src/environments/environment';
// TODO: provide environment via ENV DI token

const msalInstance = new PublicClientApplication({
  auth: {
    clientId: environment.microsoft.clientId,
    authority: environment.microsoft.authority,
    redirectUri: environment.microsoft.redirectUri,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (!containsPii) console.log(message);
      },
      logLevel: LogLevel.Info,
    },
  },
});

/** Scopes requested on sign-in; reuse them for any interactive re-login. */
export const MSAL_LOGIN_SCOPES: string[] = environment.microsoft.protectedResourcesDefaultScope;

const msalGuardConfig: MsalGuardConfiguration = {
  interactionType: InteractionType.Redirect,
  authRequest: {
    scopes: MSAL_LOGIN_SCOPES,
  },
};

const protectedResourceMap = new Map(
  environment.microsoft.protectedResources.map(({ url }) => [
    url,
    environment.microsoft.protectedResourcesDefaultScope,
  ]),
);

const msalInterceptorConfig: MsalInterceptorConfiguration = {
  interactionType: InteractionType.Redirect,
  protectedResourceMap: protectedResourceMap,
};

export const MSAL_MODULE = MsalModule.forRoot(msalInstance, msalGuardConfig, msalInterceptorConfig);

export const MSAL_PROVIDERS = [
  [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
  ],
];

export const MSAL_BOOTSTRAP_COMPONENTS = [MsalRedirectComponent];
